import {
  Box,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Flex,
  useBreakpointValue,
  VStack
} from "@chakra-ui/react";
import { useContext } from "react";

import { ContributionContext } from "./context";
import { Description } from "./description/description";
import { Footer } from "./footer/footer";
import { Tags } from "./tags/tags";
import { Header } from "./header/header";
import { Image } from "./image/image";
import { Title } from "./title/title";
import { Budgeting } from "./budgeting/budgeting";
import { Tile } from "./tile/tile";
import { Focusable } from "./focusable/focusable";

export function ContributionCard() {
  const { id, variant, showImage, imageSrc } = useContext(ContributionContext);

  const isMobile = useBreakpointValue({ base: true, lg: false }) || false;
  const commonCardProps = {
    gap: 4,
    boxShadow: "base",
    borderRadius: "md",
    variant: "unstyled",
    id: `ehq-contributionCard-${id}`,
    scrollMarginTop: { base: 180, lg: 20 }
  };

  if (variant === "elevated") {
    return (
      <Card {...commonCardProps} gap={2}>
        <Image />
        <Box p={2}>
          <CardHeader w="full">
            <Header />
          </CardHeader>
          <CardBody mt={2}>
            <Title />
            <Description />
          </CardBody>
          <CardFooter mt={4} as={VStack} align="start">
            <Tags />
            <Footer />
            <Budgeting />
          </CardFooter>
        </Box>
      </Card>
    );
  }

  if (variant === "horizontal" && !isMobile) {
    return (
      <Card direction="row" {...commonCardProps}>
        <Image />
        <VStack align="start" w="full" p={2} pl={showImage && imageSrc ? 0 : 2}>
          <CardHeader w="full">
            <Header />
          </CardHeader>
          <CardBody w="full">
            <Title />
            <Description />
          </CardBody>
          <CardFooter w="full" as={VStack} align="start">
            <Tags />
            <Footer />
            <Budgeting />
          </CardFooter>
        </VStack>
      </Card>
    );
  }

  return (
    <Card height="100%" width="100%" {...commonCardProps}>
      <CardHeader w="full" px={2} pt={3} pb={0}>
        <Header />
      </CardHeader>
      <Flex direction="column" flex={1}>
        <CardBody>
          <Focusable>
            <Image />
            <Tile>
              <Title />
              <Description />
            </Tile>
          </Focusable>
        </CardBody>
        <CardFooter mt={4} as={VStack} align="start" p={2} pt={0}>
          <Tags />
          <Footer />
          <Budgeting />
        </CardFooter>
      </Flex>
    </Card>
  );
}
